<template>
    <img v-if="avatarImage" :src="avatarImage" :class="classesImg" />
    <span v-else :class="classesText" :style="avatarBackground">
        {{ avatarText }}
    </span>
</template>

<script>
import { getAvatarColor, getUserInitials } from 'Helpers/avatarHelper';

export default {
    props: {
        firstname: {
            type: String,
            require: true,
            default: '',
        },
        lastname: {
            type: String,
            require: true,
            default: '',
        },
        avatarImage: {
            type: String,
            require: false,
            default: null,
        },
        size: {
            type: String,
            default: 'small',
            validator: (value) =>
                ['extra-small', 'small', 'medium', 'large', 'extra-large'].includes(value),
        },
    },
    computed: {
        classesImg() {
            return ['avatar', 'avatar-randomized__img', this.currentAvatarSize];
        },
        classesText() {
            return ['avatar', this.currentAvatarSize];
        },
        avatarBackground() {
            const colorToken = getAvatarColor({
                firstname: this.firstname,
                lastname: this.lastname,
            });
            return { background: `var(--${colorToken})` };
        },
        currentAvatarSize: function () {
            return this.avatarSizeClass(this.size);
        },
        avatarText: function () {
            if (this.size === 'extra-small') {
                return this.lastname?.[0] ?? this.firstname?.[0] ?? '';
            }
            return getUserInitials({ firstname: this.firstname, lastname: this.lastname });
        },
    },
    methods: {
        avatarSizeClass(size) {
            return {
                'extra-small': 'avatar-small',
                small: '',
                medium: 'avatar-big',
                large: 'avatar-xbig',
                'extra-large': 'avatar-xxbig',
            }[size];
        },
    },
};
</script>

<style lang="scss" scoped>
.avatar-randomized {
    &__img {
        padding: 0;
    }
}
</style>
